import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { DEFAULT_URL } from '~/src/features/yandex-landing/constants';

import { Container } from '~/src/features/yandex-landing/styled';

export const ContainerRoutes = styled(Container)`
    width: 1362px;
    margin-top: 38px;
    margin-bottom: 64px;
    box-sizing: content-box;
    padding: 0 90px;

    @media (max-width: ${breakPoints.sDesktop}) {
        padding: 0 34px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        padding: 0 16px;
        max-width: 288px;
        margin-bottom: 32px;
    }
`;

export const BannerWrapper = styled.div`
    height: 283px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: 79px 0 78px 55px;
    background-image: url('${DEFAULT_URL}routes-banner-img-desktop.png');
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0 4px 24px rgba(0, 0, 0, .08);

    @media (max-width: ${breakPoints.desktop}) {
        padding-left: 119px;
        background-position: top;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        padding: 84px 0 71px 43px;
        background-position: 80% 100%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        padding: 57px 0 50px 43px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        height: 524px;
        padding: 274px 0 31px 24px;
        background-image: url('${DEFAULT_URL}routes-banner-img-mobile.jpg');
        background-color: ${COLORS.white};
        background-size: contain;
        background-position: center;
    }
`;

export const RouteTitle = styled.div`
    ${FONTS.H2};

    &:after {
        content: '';
        background-image: url('${DEFAULT_URL}red-heart.png');
        background-repeat: no-repeat;
        background-size: contain;
        height: 34px;
        width: 34px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.tablet}) {
        white-space: pre;
        align-items: flex-end;
    }
`;

export const TextWrapper = styled.div`
    flex-direction: column;
    gap: 8px;
`;

export const RouteSubtext = styled.div`
    width: 70%;
    ${FONTS.S};

    @media (max-width: ${breakPoints.desktop}) {
        width: 100%;
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 70%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 34vw;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 95%;
    }
`;

export const RouteButton = styled(Button)`
    width: 289px;
    ${FONTS.H5};

    @media (max-width: ${breakPoints.desktop}) {
        margin-top: 26px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-top: 16px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        margin-top: 12px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 91%;
        margin-top: 22px;
        padding-right: 24px;
    }
`;
